import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { AppService } from '../../app.service';


@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html'
})
export class LoaderComponent implements OnInit {

  loader = true;
  loaderwithtext: any;
  currentState = '';
  private subscription: Subscription;


  constructor(private appService: AppService) { }

  ngOnInit() {
    this.loaderSubscribe();
    this.loaderSubscribeWithText();
  }

  // Loader Subscription
  private loaderSubscribe() {
    this.subscription = this.appService.loaderObservable.subscribe(
      value => { setTimeout(() => { this.loader = value; }, 0); });
  }

  private loaderSubscribeWithText() {
    this.subscription = this.appService.loaderObservableWithText.subscribe(
      value => { setTimeout(() => { this.currentState = value.componentState; this.loaderwithtext = value.componentText; }, 0); });
  }

}
